import { render, staticRenderFns } from "./ApplicantOnboardingBusinessData.vue?vue&type=template&id=789a42f6&"
import script from "./ApplicantOnboardingBusinessData.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnboardingBusinessData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports